import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { fontSizes } from '../../../../configs/fontSize'
import { UseTypeFontSize } from '../../hooks/useTypeFontSize'
import classes from './index.module.scss'

export const Switch = ({
  title,
  isI18n,
  translateProps,
  checked,
  style,
  className,
  onChange,
  isCheckOnClickText,
  allowChange,
  appendStyle,
}) => {
  const typeFontSize = UseTypeFontSize()

  const [isCheck, setIsCheck] = useState(checked)

  useEffect(() => {
    setIsCheck(!!checked)
  }, [checked])

  const onToggle = (e) => {
    e?.stopPropagation()
    if (allowChange) {
      onChange ? onChange(!isCheck) : setIsCheck(!isCheck)
    }
  }

  const onClickText = (e) => {
    e?.stopPropagation()
    if (isCheckOnClickText) {
      onToggle(e)
    }
  }

  return (
    <div className="dFlex alignItemsCenter" style={appendStyle}>
      <div
        className={classes.switchDiv}
        style={{
          backgroundColor: isCheck ? '#3DA967' : 'transparent',
          borderColor: isCheck ? 'transparent' : '#9C9C9C',
          transform: `scale(${fontSizes[typeFontSize].ratio})`,
          opacity: allowChange ? 1 : 0.4,
        }}
        onClick={onToggle}
      >
        <div
          className={classes.switchBtn}
          style={{
            left: isCheck ? 'calc(100% - 7px)' : 1,
            backgroundColor: isCheck ? '#FFFFFF' : '#9C9C9C',
          }}
        />
      </div>
      {title && (
        <span
          style={{ paddingLeft: 10, ...style }}
          className={[
            isCheckOnClickText ? 'cursorPointer' : '',
            className,
          ].join(' ')}
          onClick={onClickText}
        >
          {isI18n ? <Translate value={title} {...translateProps} /> : title}
        </span>
      )}
    </div>
  )
}

Switch.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object,
  ]),
  isI18n: PropTypes.bool,
  translateProps: PropTypes.object,
  checked: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  isCheckOnClickText: PropTypes.bool,
  onChange: PropTypes.func,
  allowChange: PropTypes.bool,
  appendStyle: PropTypes.object,
}

Switch.defaultProps = {
  isI18n: false,
  translateProps: {},
  checked: false,
  style: {},
  className: '',
  isCheckOnClickText: false,
  allowChange: true,
  appendStyle: {},
}
